module.exports = __webpack_public_path__ + "static/media/0326_IMG_LES_MURS_LAGOON_W_VLA2100_HORIZONTALE.da979370.png";